import { render } from "./ScanQRCode.vue?vue&type=template&id=48fcbeba&scoped=true"
import script from "./ScanQRCode.vue?vue&type=script&lang=js"
export * from "./ScanQRCode.vue?vue&type=script&lang=js"

import "./ScanQRCode.vue?vue&type=style&index=0&id=48fcbeba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48fcbeba"]])

export default __exports__